import React from 'react';
import Banner from "../Banner/Banner";
import Reviews from "../Reviews/Reviews";

const Home = () => {
    return (
        <>
            <Banner/>
            <Reviews/>
        </>
    );
};

export default Home;